import wordmarkLight from '../assets/luno-wordmark.svg'
import wordmarkDark from '../assets/luno-wordmark-dark.svg'

type Props = {
  // Height of the wordmark lockup in px; width scales from the SVG aspect.
  height?: number
  // Extra classes on the wrapper.
  className?: string
  // Accessible label for the lockup. Defaults to the brand name.
  label?: string
}

// The full "luno" lockup — "lun" in the brand serif closed by the teal-gradient
// orb as the trailing "o" — from the exact Figma export (style board nodes
// 20:86 light / 42:1369 dark). The letterforms are outlined in the SVG, so no
// web font is required and the mark is pixel-faithful. Light mode = black "lun";
// dark mode = white "lun" (Figma's dark-mode frame), swapped on theme.
export default function LunoWordmark({
  height = 28,
  className = '',
  label = 'Luno Learning',
}: Props) {
  return (
    <span
      className={`inline-flex items-center ${className}`}
      style={{ height }}
      role="img"
      aria-label={label}
    >
      <img src={wordmarkLight} alt="" aria-hidden className="block h-full w-auto dark:hidden" />
      <img src={wordmarkDark} alt="" aria-hidden className="hidden h-full w-auto dark:block" />
    </span>
  )
}
